export default __webpack_public_path__ + "static/media/case-study.ba3c02f9.jpg";